// extracted by mini-css-extract-plugin
module.exports = {"default":"Loader_default__2OR2B","center":"Loader_center__1rLFC"};